import React from "react";

export default function SitesIcon() {
  return (
    <svg
      version="1.1"
      width="26"
      height="26"
      x="0"
      y="0"
      viewBox="0 0 64 64"
    >
      <g>
        <path
          d="M47 10c-3.863 0-7 3.137-7 7s3.137 7 7 7 7-3.137 7-7-3.137-7-7-7zm0 2c2.76 0 5 2.24 5 5s-2.24 5-5 5-5-2.24-5-5 2.24-5 5-5zM48 29v-2a1 1 0 0 0-2 0v2a1 1 0 0 0 2 0zM56.707 25.293l-2-2a1.001 1.001 0 0 0-1.414 1.414l2 2a1.001 1.001 0 0 0 1.414-1.414zM59 16h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2zM55.293 7.293l-2 2a1 1 0 0 0 1.414 1.414l2-2a1 1 0 0 0-1.414-1.414zM40.707 9.293l-2-2a1.001 1.001 0 0 0-1.414 1.414l2 2a1.001 1.001 0 0 0 1.414-1.414zM46 5v2a1 1 0 0 0 2 0V5a1 1 0 0 0-2 0zM39.293 23.293l-2 2a1 1 0 0 0 1.414 1.414l2-2a1 1 0 0 0-1.414-1.414zM37 16h-2a1 1 0 0 0 0 2h2a1 1 0 0 0 0-2z"
          fill="currentColor"
          opacity="1"
          data-original="#000000"
        ></path>
        <path
          d="M6.719 34 4.03 23.243A.998.998 0 0 1 5 22h30a1 1 0 0 1 0 2h-7.719l2.5 10h8.939l-.94-3.757a1 1 0 0 1 1.941-.486L40.781 34h7.938l-.189-.757a1 1 0 0 1 1.94-.486L50.781 34H52a1 1 0 0 1 0 2h-.719l2.689 10.757A.998.998 0 0 1 53 48H33v10h26a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2h20V48H11a1 1 0 0 1-.97-.757L7.219 36H6a1 1 0 0 1 0-2zM27 48v10h4V48zm-7.281-2-2.5-10H9.281l2.5 10zm-.438-10 2.5 10h8.938l-2.5-10zm11 0 2.5 10h8.938l-2.5-10zm18.938 0h-7.938l2.5 10h7.938zM6.281 24l2.5 10h7.939l-2.5-10zm10 0 2.5 10h8.939l-2.5-10z"
          fill="currentColor"
          opacity="1"
          data-original="#000000"
        ></path>
      </g>
    </svg>
  );
}
